import axios from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { message } from 'antd';

declare module 'axios' {
  interface AxiosRequestConfig {
    skipGlobalErrorMessage?: boolean;
  }
}

interface CustomAxiosInstance extends AxiosInstance {
  create: (config: AxiosRequestConfig) => AxiosInstance;
}

// 创建 axios 实例
export const API_BASE = process.env.REACT_APP_API_URL || '';

const request = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
}) as CustomAxiosInstance;

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  (error) => {
    const skipGlobalErrorMessage = error.config?.skipGlobalErrorMessage;
    const requestUrl = error.config?.url || '';
    const isLoginRequest = requestUrl.includes('/auth/login');

    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (isLoginRequest) {
            if (!skipGlobalErrorMessage) {
              message.error(error.response.data?.message || '用户名或密码错误');
            }
          } else {
            // 未授权，清除 token 并跳转到登录页
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
          }
          break;
        case 403:
          if (!skipGlobalErrorMessage) message.error('没有权限访问该资源');
          break;
        case 404:
          if (!skipGlobalErrorMessage) message.error('请求的资源不存在');
          break;
        case 500:
          if (!skipGlobalErrorMessage) message.error('服务器错误');
          break;
        default:
          if (!skipGlobalErrorMessage) message.error(error.response.data.message || '请求失败');
      }
    } else if (error.code === 'ECONNABORTED') {
      if (!skipGlobalErrorMessage) {
        message.error('请求超时，同步任务可能仍在后台继续，请稍后刷新查看结果');
      }
    } else {
      if (!skipGlobalErrorMessage) message.error('网络错误，请检查网络连接');
    }
    return Promise.reject(error);
  }
);

request.create = (config: AxiosRequestConfig) => {
  return axios.create(config);
};

export default request; 
